import { Component } from '@angular/core';
import { SeoService } from '@services/seo.service';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.css']
})
export class NotFoundComponent {
  constructor(private seo: SeoService) {
    this.seo.update({
      title: 'Página no encontrada | Clave Winds',
      description: 'La página solicitada no existe o cambió de dirección. Regresa al catálogo de Clave Winds.',
      robots: 'noindex, follow'
    });
  }
}
